module.exports = __webpack_public_path__ + "static/media/addnotirightside.1b2aa3ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/Assets/img/addnotirightside.png
// module id = 996
// module chunks = 0